export default "/images/vendor/flag-icons/flags/4x3/ua.svg?423c68f9fb154fb2749b64a16d0968e1";